import { initialState } from './initialState';
import { saveToLocalStorage, updateHtmlDirection, applyDarkMode, applyAnimation, determineDarkMode } from './helpers';

// Atualiza a direção do layout (ltr ou rtl), salva no localStorage e atualiza o atributo no HTML
function toggleDirection(state: typeof initialState, payload: any) {
    saveToLocalStorage('direction', payload);
    updateHtmlDirection(payload);
    return { ...state, direction: payload };
}

// Ativa ou desativa o loader principal da aplicação
function toggleMainLoader(state: typeof initialState, payload: any) {
    return { ...state, isShowMainLoader: payload };
}

// Define o layout principal (exemplo: 'app' ou 'auth')
function setMainLayout(state: typeof initialState, payload: any) {
    return { ...state, mainLayout: payload };
}

// Alterna o tema da aplicação (light, dark, system), atualizando localStorage e aplicando classe no body
function toggleTheme(state: typeof initialState, payload: any) {
    const theme = payload || state.theme;
    saveToLocalStorage('theme', theme);

    const isDarkMode = determineDarkMode(theme);
    applyDarkMode(isDarkMode);

    return { ...state, theme, isDarkMode };
}

// Alterna o tipo de menu e fecha a sidebar, salvando a preferência
function toggleMenu(state: typeof initialState, payload: any) {
    const menu = payload || state.menu;
    saveToLocalStorage('menu', menu);
    return { ...state, sidebar: false, menu };
}

// Alterna o layout da aplicação (full, boxed-layout), salvando a preferência
function toggleLayout(state: typeof initialState, payload: any) {
    const layout = payload || state.layout;
    saveToLocalStorage('layout', layout);
    return { ...state, layout };
}

// Alterna a direção do texto (rtl, ltr), salva no localStorage e atualiza o atributo no HTML
function toggleRTL(state: typeof initialState, payload: any) {
    const rtlClass = payload || state.rtlClass;
    saveToLocalStorage('rtlClass', rtlClass);
    updateHtmlDirection(rtlClass);
    return { ...state, rtlClass };
}

// Aplica uma animação CSS, adiciona classes necessárias e salva a preferência
function toggleAnimation(state: typeof initialState, payload: any) {
    const animation = payload?.trim() || '';
    saveToLocalStorage('animation', animation);
    applyAnimation(animation);
    return { ...state, animation };
}

// Alterna o estilo da navbar (sticky, floating, static) e salva a preferência
function toggleNavbar(state: typeof initialState, payload: any) {
    const navbar = payload || state.navbar;
    saveToLocalStorage('navbar', navbar);
    return { ...state, navbar };
}

// Alterna o modo semiescuro e salva a preferência
function toggleSemidark(state: typeof initialState, payload: any) {
    const semidark = payload || false;
    saveToLocalStorage('semidark', semidark);
    return { ...state, semidark };
}

// Altera o idioma da aplicação e salva a preferência no localStorage
function toggleLocale(state: typeof initialState, payload: any) {
    const locale = payload || state.locale;
    saveToLocalStorage('i18n_locale', locale);
    return { ...state, locale };
}

// Alterna a visibilidade da sidebar (abre ou fecha)
function toggleSidebar(state: typeof initialState) {
    return { ...state, sidebar: !state.sidebar };
}

// Reducer principal que chama as funções auxiliares com base no tipo da ação
export function indexReducer(state = initialState, action: any) {
    const { type, payload } = action;

    switch (type) {
        case 'toggleDirection':
            return toggleDirection(state, payload);

        case 'toggleMainLoader':
            return toggleMainLoader(state, payload);

        case 'setMainLayout':
            return setMainLayout(state, payload);

        case 'toggleTheme':
            return toggleTheme(state, payload);

        case 'toggleMenu':
            return toggleMenu(state, payload);

        case 'toggleLayout':
            return toggleLayout(state, payload);

        case 'toggleRTL':
            return toggleRTL(state, payload);

        case 'toggleAnimation':
            return toggleAnimation(state, payload);

        case 'toggleNavbar':
            return toggleNavbar(state, payload);

        case 'toggleSemidark':
            return toggleSemidark(state, payload);

        case 'toggleLocale':
            return toggleLocale(state, payload);

        case 'toggleSidebar':
            return toggleSidebar(state);

        default:
            return state;
    }
}
